const SETTING_INITIAL_STATE = {
	tags: [],
};

export default SETTING_INITIAL_STATE;
